const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export const normalizeTenantHost = (raw) => {
  if (!raw) return "";
  return String(raw)
    .replace(/^https?:\/\//, "")
    .split(":")[0]
    .toLowerCase()
    .trim();
};

const getNonTenantHosts = () =>
  new Set(
    [
      "lembaga.halal.go.id",
      "api.edukasihalalindonesia.com",
      process.env.REACT_APP_SIHALAL_HOST,
    ]
      .filter(Boolean)
      .map(normalizeTenantHost),
  );

const resolveTenantHostFromBrowser = () => {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return "";
  }

  const host = window.location.hostname.toLowerCase();
  if (getNonTenantHosts().has(host)) {
    return "";
  }

  if (LOCAL_HOSTS.has(host)) {
    return (
      normalizeTenantHost(process.env.REACT_APP_DEV_TENANT_HOST || "") ||
      "localhost"
    );
  }

  return host;
};

/** Pin host tenant di awal sesi; reset jika domain berubah (pindah tenant). */
export const initTenantHost = () => {
  const current = resolveTenantHostFromBrowser();
  if (!current || typeof sessionStorage === "undefined") return;

  const pinned = normalizeTenantHost(sessionStorage.getItem("tenantHost") || "");
  if (!pinned || pinned !== current) {
    sessionStorage.setItem("tenantHost", current);
  }
};

/**
 * Host website tenant untuk header X-Tenant-Host.
 * Prioritas: sessionStorage (domain saat buka) → domain browser → env dev.
 */
export const getTenantHost = () => {
  if (typeof sessionStorage !== "undefined") {
    const pinned = sessionStorage.getItem("tenantHost");
    if (pinned) {
      return normalizeTenantHost(pinned);
    }
  }

  const fromBrowser = resolveTenantHostFromBrowser();
  if (fromBrowser) {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem("tenantHost", fromBrowser);
    }
    return fromBrowser;
  }

  const configured = normalizeTenantHost(
    process.env.REACT_APP_TENANT_HOST ||
      process.env.REACT_APP_DEV_TENANT_HOST ||
      "",
  );
  if (configured) return configured;

  return "localhost";
};
